import axios from "axios";
import { unwrapResponse } from "./chatHelpers";

export function retrieveChatContacts({ page = 0, page_size = 100 } = {}) {
  return axios
    .post("/retrieve-chat-contacts/", { page, page_size })
    .then(({ data }) => unwrapResponse(data) || { data: [], total: 0 });
}

export function retrieveConversations({ page = 0, page_size = 50 } = {}) {
  return axios
    .post("/retrieve-conversations/", { page, page_size })
    .then(({ data }) => unwrapResponse(data) || { data: [], total: 0 });
}

export function retrieveConversation(conversationId) {
  return axios
    .get(`/conversations/${conversationId}/`)
    .then(({ data }) => unwrapResponse(data));
}

export function createConversation(payload) {
  return axios
    .post("/conversations/", payload)
    .then(({ data }) => unwrapResponse(data));
}

export function retrieveMessages(conversationId, { page = 0, page_size = 50 } = {}) {
  return axios
    .post(`/conversations/${conversationId}/retrieve-messages/`, {
      page,
      page_size,
    })
    .then(({ data }) => unwrapResponse(data) || { data: [], total: 0 });
}

export function createMessage(conversationId, payload) {
  return axios
    .post(`/conversations/${conversationId}/messages/`, payload)
    .then(({ data }) => unwrapResponse(data));
}

export function markConversationRead(conversationId) {
  return axios
    .post(`/conversations/${conversationId}/mark-read/`, {})
    .then(({ data }) => unwrapResponse(data));
}

export function addConversationParticipant(conversationId, payload) {
  return axios
    .post(`/conversations/${conversationId}/participants/`, payload)
    .then(({ data }) => unwrapResponse(data));
}

export function leaveConversation(conversationId) {
  return axios
    .post(`/conversations/${conversationId}/leave/`, {})
    .then(({ data }) => unwrapResponse(data));
}

export function pingTyping(conversationId) {
  return axios
    .post(`/conversations/${conversationId}/typing/`, {})
    .then(({ data }) => unwrapResponse(data));
}

export function uploadChatAsset(file, actor) {
  const formData = new FormData();
  formData.append("tempfile", file);
  formData.append("variety", 3);
  if (actor?.kind === "admin") formData.append("admin_id", actor.id);
  if (actor?.kind === "user") formData.append("user_id", actor.id);
  return axios.post("/assets/", formData).then(({ data }) => unwrapResponse(data));
}
